export const translations = {
  pending: {
    pt: 'Pendente',
    en: 'Pending',
    es: 'Pendiente',
    de: 'Ausstehend',
  },
  approved: {
    pt: 'Aprovado',
    en: 'Approved',
    es: 'Aprobado',
    de: 'Genehmigt',
  },
  rejected: {
    pt: 'Reprovado',
    en: 'Rejected',
    es: 'Rechazado',
    de: 'Abgelehnt',
  },
}